import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { ReactComponent as NIHLogo } from "../assets/nih.svg";
import { ReactComponent as NSFLogo } from "../assets/NSF_logo.svg";
import { hasCreditsContent } from "./credits/CreditsContent";
import {
  getViewerPanelPaddingSx,
  viewerActionButtonLabelSx,
  viewerPanelEyebrowSx,
  viewerPanelSurfaceSx,
  viewerPillActionButtonSx,
} from "./unityWebViewer/panelStyles";
import { useLocalization } from "../localization/LocalizationContext";

const textValue = (value) =>
  typeof value === "string" || typeof value === "number" ? String(value) : "";

const AttributionBox = ({
  creditsPanelId,
  creditsOpen,
  id,
  onOpenCredits,
  open,
  system,
}) => {
  const { dir, t } = useLocalization();
  if (!open) {
    return null;
  }

  const aboutText = textValue(system?.credits?.aboutText).trim();
  const showCreditsAction = hasCreditsContent(system?.credits);

  return (
    <Box
      id={id}
      className="viewer-attribution"
      role="dialog"
      aria-label={t("viewer.info.title")}
      sx={{
        ...viewerPanelSurfaceSx,
        ...getViewerPanelPaddingSx(false),
        width: "100%",
        minWidth: 0,
        color: "var(--label-text, #f2fffc)",
        overflow: "hidden",
        boxSizing: "border-box",
        pointerEvents: "auto",
      }}
    >
      <Box sx={{ textAlign: dir === "rtl" ? "right" : "left" }}>
        <Typography
          variant="overline"
          sx={viewerPanelEyebrowSx}
        >
          {t("viewer.info.about")}
        </Typography>
        <Box
          data-testid="about-description-row"
          sx={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 1.5,
            mt: 0.35,
          }}
        >
          <Stack
            data-testid="about-description"
            spacing={1}
            sx={{
              flex: "0 1 286px",
              width: 286,
              minWidth: 0,
              maxWidth: "100%",
              overflowWrap: "anywhere",
              wordBreak: "break-word",
            }}
          >
            {aboutText ? (
              <Typography
                variant="caption"
                sx={{
                  display: "block",
                  lineHeight: 1.45,
                  opacity: 0.9,
                  whiteSpace: "pre-wrap",
                }}
              >
                {aboutText}
              </Typography>
            ) : (
              <Typography
                variant="caption"
                sx={{ display: "block", lineHeight: 1.45, opacity: 0.72 }}
              >
                {t("viewer.info.about_empty")}
              </Typography>
            )}
          </Stack>
          {showCreditsAction && (
            <Box
              component="button"
              type="button"
              aria-controls={creditsOpen ? creditsPanelId : undefined}
              aria-expanded={creditsOpen}
              onClick={onOpenCredits}
              sx={viewerPillActionButtonSx}
            >
              <Typography
                component="span"
                className="control-label"
                sx={viewerActionButtonLabelSx}
              >
                {t("credits.open")}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1.2 }}>
        <Typography variant="caption" align="left" sx={{ opacity: 0.86 }}>
          {t("credits.funding_support")}
        </Typography>
        <NIHLogo width="50px" />
        <NSFLogo width="35px" />
      </Box>
    </Box>
  );
};

export default AttributionBox;
